import { Pipe, PipeTransform } from '@angular/core';
import {Activity} from "@model/product/activity.model";

/**
 * SortByDatePipe
 *
 * @export SortByDatePipe
 */
@Pipe({
  name: 'sortByDate'
})

export class SortByDatePipe implements PipeTransform {

  /**
   * Sorts Activity Groups by Date either assending or desending
   *
   * @param value Array of Objects of type { date: string, activities: Array<Activity> }
   * @param selectedFilter Either 'D', 'W' or 'M'
   * @param dir determines whether to sort in assending or descending order by date
   * @returns Sorted Array
   */
  transform(value: Array<{ date: string, activities: Array<Activity>, isCollapsed?: boolean }>, selectedFilter?: string, dir?: boolean)
    : Array<{ date: string, activities: Array<Activity>, isCollapsed?: boolean }> {
    return value.sort((a, b) => {
      if (dir) {
        switch (selectedFilter) {
          case 'D':
            return new Date(a.date).getTime() - new Date(b.date).getTime();
          case 'W':
            return new Date(a.activities[0].timestamp).getTime() - new Date(b.activities[0].timestamp).getTime();
          case 'M':
            return new Date(a.activities[0].timestamp).getTime() - new Date(b.activities[0].timestamp).getTime();
        }
      } else {
        switch (selectedFilter) {
          case 'D':
            return new Date(b.date).getTime() - new Date(a.date).getTime();
          case 'W':
            return new Date(b.activities[0].timestamp).getTime() - new Date(a.activities[0].timestamp).getTime();
          case 'M':
            return new Date(b.activities[0].timestamp).getTime() - new Date(a.activities[0].timestamp).getTime();
        }
      }
    });
  }

}
